var b = Object.defineProperty, C = Object.defineProperties;
var I = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var u = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var p = (s, t, e) => t in s ? b(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e, f = (s, t) => {
  for (var e in t || (t = {}))
    u.call(t, e) && p(s, e, t[e]);
  if (o)
    for (var e of o(t))
      m.call(t, e) && p(s, e, t[e]);
  return s;
}, w = (s, t) => C(s, I(t));
var g = (s, t) => {
  var e = {};
  for (var i in s)
    u.call(s, i) && t.indexOf(i) < 0 && (e[i] = s[i]);
  if (s != null && o)
    for (var i of o(s))
      t.indexOf(i) < 0 && m.call(s, i) && (e[i] = s[i]);
  return e;
};
import { a as L, j as n } from "../../../jsx-runtime-c20f6c15.mjs";
import { forwardRef as j, createElement as V } from "react";
import h from "clsx";
import E from "../../../shared/icons/i-close-x.svg.mjs";
const S = "_container_suh61_8", X = "_leftAccessory_suh61_15", q = "_rightAccessory_suh61_16", z = "_clickable_suh61_48", B = "_input_suh61_52", D = "_highlighted_suh61_76", F = "_withLeftAccessory_suh61_81", G = "_withRightAccessory_suh61_85", H = "_invalid_suh61_89", J = "_dropdownView_suh61_97", c = {
  container: S,
  leftAccessory: X,
  rightAccessory: q,
  clickable: z,
  input: B,
  highlighted: D,
  withLeftAccessory: F,
  withRightAccessory: G,
  invalid: H,
  dropdownView: J
};
function K(M, k) {
  var d = M, {
    containerClassName: s,
    leftAccessory: t,
    rightAccessory: e,
    className: i,
    invalid: y = !1,
    highlighted: A = !1,
    clearable: r = !1,
    rightAccessoryOnClick: l,
    leftAccessoryOnClick: a,
    dropdownView: _,
    as: v = "input"
  } = d, N = g(d, [
    "containerClassName",
    "leftAccessory",
    "rightAccessory",
    "className",
    "invalid",
    "highlighted",
    "clearable",
    "rightAccessoryOnClick",
    "leftAccessoryOnClick",
    "dropdownView",
    "as"
  ]);
  const x = h(
    c.input,
    {
      [c.highlighted]: A,
      [c.invalid]: y,
      [c.withLeftAccessory]: !!t,
      [c.withRightAccessory]: !!e || r
    },
    i
  ), R = V(v, w(f({
    type: "text"
  }, N), {
    ref: k,
    className: x
  }));
  return /* @__PURE__ */ L("div", { className: h(c.container, s), children: [
    t && /* @__PURE__ */ n(
      "div",
      {
        className: h(c.leftAccessory, {
          [c.clickable]: !!a
        }),
        onClick: a,
        role: "presentation",
        children: t
      }
    ),
    R,
    (e || r) && /* @__PURE__ */ n(
      "div",
      {
        className: h(c.rightAccessory, {
          [c.clickable]: !!l
        }),
        onClick: l,
        role: "presentation",
        children: e || /* @__PURE__ */ n(E, {})
      }
    ),
    _ && /* @__PURE__ */ n("div", { className: c.dropdownView, children: _ })
  ] });
}
const Y = j(K);
export {
  Y as default
};
